function showByRouteDirective(Identity, $state) {
	return ({
		restrict : "A",
		transclude : false,
		link : function(scope, element, attrs) {
			function getName(ref){
				// si tiene parametros se obtiene solo el nombre
				var idx = ref.indexOf("(");
				if (idx >= 0) {
					return ref.substring(0, idx);
				}
				return ref;
			}
			
			scope.$watch(attrs.showByRoute, function(value, oldValue) {
				if (!_.isString(attrs.showByRoute)) {
					throw 'hasRole value must be a string'
				}

				var routeName = attrs.showByRoute;

				//si esta al mismo nivel que la etiqueta de la directiva
				var rnam = element.attr("ui-sref");
				if (!angular.isUndefined(rnam)) {
					routeName = getName(rnam);
				} else if (angular.isUndefined(attrs.showByRoute) || attrs.showByRoute == "") {
					// se lee del elemento a el atribbuto ui-sref
					var E_a = element.find("a");
					if (E_a) {
						var ref = E_a.attr("ui-sref");
						if (ref) {
							routeName = getName(ref);
						}
					}
				}

				var sta = $state.get(routeName);
				if (!sta) {
					element.hide();
					return;
				}
				if (!sta.data) {
					element.hide();
					return;
				}
				if (!sta.data.permissions) {
					element.hide();
					throw 'se deben haber registrado permisos'
				}

				element.hide();
				for ( var p in sta.data.permissions.only) {
					var role = sta.data.permissions.only[p];
					if (Identity.hasRole(role)) {
						element.show();
						break;
					}
				}
			}, true);
		}
	});
}

module.directive('showByRoute', [ 'Identity', '$state', showByRouteDirective ]);